import axios from "axios";
import { getToken } from "../../middlewares/auth";

const setedigitalApi = axios.create({
  // baseURL: "http://localhost:4776/api",
  baseURL: "https://aajump-api.sete.digital/api",
});

setedigitalApi.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default setedigitalApi;
